/* Prologo: align Flickity viewport to the selected image's intrinsic aspect. */
(() => {
  function init(root) {
    if (!root || root.dataset.pcChoiceBound === '1') return;
    const wrapper = root.querySelector('[data-slideshow-wrapper]');
    if (!wrapper) return;
    root.dataset.pcChoiceBound = '1';
    let raf = 0;
    let lastViewportHeight = 0;

    function resizeSelected() {
      raf = 0;
      const slides = [...wrapper.querySelectorAll('.prologo-slideshow__slide')];
      if (!slides.length) return;
      const selected = slides.find(slide => slide.classList.contains('is-selected')) || slides[0];
      const frame = selected.querySelector('.prologo-slideshow__frame');
      const viewport = wrapper.querySelector('.flickity-viewport');
      if (!frame || !viewport) return;
      const height = Math.round(frame.getBoundingClientRect().height);
      if (!height || Math.abs(height - lastViewportHeight) < 1) return;
      lastViewportHeight = height;
      viewport.style.setProperty('height', `${height}px`, 'important');
    }
    function schedule() {
      if (!raf) raf = requestAnimationFrame(resizeSelected);
    }

    // Pipeline initializes the carousel asynchronously, so observe its DOM.
    const observer = new MutationObserver(mutations => {
      if (mutations.some(m => m.type === 'childList' ||
        (m.type === 'attributes' && m.target.classList && m.target.classList.contains('prologo-slideshow__slide')))) schedule();
    });
    observer.observe(wrapper, {subtree:true, childList:true, attributes:true, attributeFilter:['class']});
    window.addEventListener('resize', schedule, {passive:true});
    window.addEventListener('load', schedule, {once:true});
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(schedule);
      root.querySelectorAll('.prologo-slideshow__frame').forEach(el => ro.observe(el));
    }
    schedule();
    setTimeout(schedule, 250);
    setTimeout(schedule, 900);
  }
  function start() {
    document.querySelectorAll('.section-slideshow.prologo-slideshow--responsive').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', start);
})();
